import React from 'react';

import { L10nPhone } from '@travel/i18n';
import { Telephone } from '@travel/icons/ui';
import type { ProviderInformation } from '@travel/traveler-core/types/providerInformation';
import { isEmptyArray } from '@travel/utils';

import { Translate } from '../../../../core/translate';

import styles from './basicInformation.module.scss';

export default function PhoneInfo(props: { provider: ProviderInformation; isMobile: boolean }) {
  const { provider, isMobile } = props;
  if (isEmptyArray(provider.contact?.phoneInfo)) {
    return null;
  }

  return (
    <div className={styles.rowItem}>
      <div className={styles.leftContent}>
        {isMobile && <Translate id="Provider_Info.Basic_Info.Hotel_Info.Phone" />}
        {!isMobile && <Telephone size={16} />}
      </div>
      <div className={styles.rightContent}>
        {provider.contact.phoneInfo.map((phone, index) => (
          <React.Fragment key={phone}>
            {index > 0 && ', '}
            <a href={`tel:${phone}`}>
              <L10nPhone value={phone} country="JPN" />
            </a>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
